import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { NoWidgetDataComponent } from '../../../../components/my-brand-screen/no-widget-data/no-widget-data.component';
import { WidgetValueField } from '../../../types/common';
import { Format } from '../../../../services/util.service';
import { MyCompetitionPerformanceWidgetResponse } from '../../../../components/my-competition-screen/types';
import { LoaderComponent } from '../../loader/loader.component';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';
import { SplineChartComponent } from './spline-chart/spline-chart.component';
import { AreaChartComponent } from './area-chart/area-chart.component';
import { PerformanceComparisonMetric } from '../../../../components/my-brand-screen/types';

@Component({
  selector: 'app-performance-over-time',
  standalone: true,
  imports: [
    NgIf,
    NoWidgetDataComponent,
    LoaderComponent,
    AssetVersionPipe,
    SplineChartComponent,
    AreaChartComponent,
  ],
  templateUrl: './performance-over-time.component.html',
  styleUrl: './performance-over-time.component.scss',
})
export class PerformanceOverTimeComponent {
  @Input() brandColors: Record<string, string> = {};
  @Input() brandLineColorsMap: Record<string, string> = {};
  @Input() metric: string | null = null;
  @Input() format: Format = 'fractionPercentage';
  @Input() valueField: WidgetValueField = '';
  @Input() data?: MyCompetitionPerformanceWidgetResponse;
  @Input() loading = false;
  @Input() isUnderDateThreshold = false;

  get isShareOfVoice(): boolean {
    return this.metric === PerformanceComparisonMetric.SHARE_OF_VOICE;
  }

  get isPerformanceData(): boolean {
    return !!this.data;
  }
}
